import * as URLConfig from "@frameworks/web/config/domain";
const config = URLConfig.config;
const ticketBase = "complaint";
const TicketsConfigURL = {
    getTicketsDataUrl: config.jmw + config.jmw_login + ticketBase,
    createTicketUrl: config.jmw + config.jmw_login + ticketBase
};
export default TicketsConfigURL;
